<div class="bank-statement-overview">
  @if (isInternalUser) {
    <div class="row mb-4">
      <div class="col-12">
        <div fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="10px"
          fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="center start">
          @if (canRequestHistoricalData()) {
            <button mat-stroked-button color="primary"
              (click)="onRequestHistoricalData()"
              class="w-lt-md-100">
              <span class="mdi mdi-history"></span>
              Request Historical Data
            </button>
          }
          <button mat-flat-button color="primary"
            (click)="onConfirmAccountSelection()"
            class="w-lt-md-100">
            Confirm Account Selection
          </button>
        </div>
      </div>
    </div>
  }

  <div class="row mb-4">
    <div class="col-12">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="width-100 mb-2">
        @for (column of columnsToDisplay; track column) {
          <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'column-width-3': column === 'BankName' || column === 'BSBAccNumber',
            'column-width-2': column === 'AccHolder' || column === 'AccName' || column === 'currentBalance' || column === 'TotalCredit',
            'column-width-1': column === 'LoanCreditFlag',
            'column-width-version': column === 'version',
            'column-width-icon': column === 'icon' || column === 'selector',
            'text-align-right': needAlignRight(column)
          }">     
              <div class="cell">{{getColumnTitles(column)}}</div>
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'text-align-right': needAlignRight(column)}" (click)="onClickRow(element)">
              @if (column === 'icon') {
                <div class="cell">
                  @if (expandedElement === element) {
                    <span class="mdi mdi-chevron-up"></span>
                  }
                  @if (expandedElement !== element) {
                    <span class="mdi mdi-chevron-down"></span>
                  }
                </div>
              }
              @if (column === 'selector') {
                <div class="cell">
                  <mat-checkbox color="primary" [formControl]="accountFilter[element.id]" (click)="$event.stopPropagation()"></mat-checkbox>
                </div>
              }
              @if (column === 'version') {
                <div class="cell version-cell" (click)="$event.stopPropagation()">
                  @if (hasMultipleVersions(element)) {
                    <div class="version-display">
                      <div class="version-info">
                        <div class="version-label">
                          @if (element.isLatestVersion !== false) {
                            <span class="current-badge">Latest</span>
                          }
                          @if (element.isLatestVersion === false) {
                            <span class="historical-badge">Historical</span>
                          }
                        </div>
                        <div class="version-date-text">{{ formatUploadDate(element.loadDate) }}</div>
                        <div class="version-time-text">{{ formatUploadTime(element.loadDate) }} | {{ getDays(element) }}</div>
                      </div>
                      <button mat-icon-button [matMenuTriggerFor]="versionMenu" class="version-button" title="Switch version">
                        <span class="mdi mdi-swap-vertical"></span>
                      </button>
                    </div>
                    <mat-menu #versionMenu="matMenu" class="version-menu">
                      @for (version of getVersionsForAccount(element); track version.loadDate) {
                        <button mat-menu-item (click)="selectVersion(element, version)" class="version-menu-item"
                          [class.selected-version]="version.id === element.id">
                          <span class="version-menu-datetime">
                            {{ formatUploadDate(version.loadDate) }} {{ formatUploadTime(version.loadDate) }}
                          </span>
                          @if (version.isLatestVersion) {
                            <span class="latest-badge">Latest</span>
                          }
                          @if (version.id === element.id) {
                            <span class="mdi mdi-check check-icon"></span>
                          }
                        </button>
                      }
                    </mat-menu>
                  }
                  @if (!hasMultipleVersions(element)) {
                    <div class="version-single">
                      <span class="current-badge">Latest</span>
                      <div class="version-date-text">{{ formatUploadDate(element.loadDate) }}</div>
                      <div class="version-time-text">{{ formatUploadTime(element.loadDate) }} | {{ getDays(element) }}</div>
                    </div>
                  }
                </div>
              }
              @if (column !== 'icon' && column !== 'selector' && column !== 'version') {
                <div class="cell" (click)="onClickRow(element)">
                    @if (needCurrencyPipe(column)) {
                        {{getColumnValues(element, column) | looseCurrency}}
                    }
                    @if (!needCurrencyPipe(column)) {
                      {{getColumnValues(element, column)}}
                    }
                </div>
              }
            </td>
          </ng-container>
        }

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element; let i = dataIndex" class="expanded-row" [attr.colspan]="columnsToDisplay.length">
            <div class="example-element-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="row mt-3">
                <div class="col">
                  <div class="mat-h4-custom">Transaction Summary</div>
                  <transaction-summary [data]="element"></transaction-summary>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <div class="mat-h4-custom">Decision Metrics</div>
                  <decision-metrics [data]="element"></decision-metrics>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (dblclick)="viewAccountTransactions(element)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>
    </div>
  </div>
  @if (data && data.Dishonours) {
  <div class="mt-4">
    <div class="mat-h4-custom">Dishonours</div>
      @if (!isEmpty(data.Dishonours, 'dishonours')) {
        <dishonours-table [data]="data.Dishonours.summary"></dishonours-table>
        <div class="mat-h4-custom sub-title">Dishonour Transactions</div>
        <transaction-table [data]="data.Dishonours.transactions" [type]="'dishonour'"></transaction-table>
      }
      @if (isEmpty(data.Dishonours, 'dishonours')) {
        <span class="notes">No dishonour transactions.</span>
      }
    </div>
  }
  @if (data && data.Overdrawn) {
  <div class="mt-4">
    <div class="mat-h4-custom">Overdrawn</div>
      @if (!isEmpty(data.Overdrawn, 'overdrawn')) {
        <overdrawn-table [data]="data.Overdrawn.summary"></overdrawn-table>
        <div class="mat-h4-custom sub-title">Overdrawn Transactions</div>
        <transaction-table [data]="data.Overdrawn.transactions" [type]="'overdrawn'"></transaction-table>
      }
    @if (isEmpty(data.Overdrawn, 'overdrawn')) {
      <span class="notes">No overdrawn transactions.</span>
    }
  </div>
}
@if (data && data.LenderList) {
  <div class="mt-4">
    <div class="mat-h4-custom">Non Preferred Lender Summary</div>
      @if (!isEmpty(data.LenderList, 'non-preferred-lender')) {
        <non-preferred-lender-summary [data]="data.LenderList.summary"></non-preferred-lender-summary>
        <div class="mat-h4-custom sub-title">Non Preferred Lender Transactions</div>
        <transaction-table [data]="data.LenderList.transactions" [type]="'non-preferred-lender'"></transaction-table>
      }
    @if (isEmpty(data.LenderList, 'non-preferred-lender')) {
      <span class="notes">No relationship with non-preferred lenders.</span>
    }
  </div>
}

  <div class="mt-4">
    <div class="mat-h4-custom">Categories</div>
    @if (data && data.transactionsByCategory) {
      <categories-table [data]="filteredTransactionsByCategory"
        [accounts]="filteredAccounts"
        [selectedAccounts]="filteredSelectedAccounts">
      </categories-table>
    }
  </div>

  <div class="row mb-4">
    <div class="col-12">
      <div class="mat-h4-custom">Full Transaction List</div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12" id="transaction-list">
      @if (data && data.transactionsByCategory) {
        <full-transaction-list 
          [transactionsByCategory]="filteredTransactionsByCategory" 
          [accounts]="filteredAccounts"
          [selectedAccounts]="filteredSelectedAccounts"
        ></full-transaction-list>
      }
    </div>
  </div>
</div>
